import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

const line = (width: string, height: string) => ({ width, height, margin: '0' });

@Component({
  selector: 'cipo-module-config-designer-skeleton',
  templateUrl: './designer-skeleton.component.html',
  imports: [NgxSkeletonLoaderModule, TranslateModule],
  host: { class: 'cipo--display--block cipo--height--full' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    .designer-skeleton__item {
      background-color: var(--white);
    }
  `,
})
export class ModuleConfigDesignerSkeletonComponent {
  readonly label = input.required<string>();
  readonly preview = input(false);

  readonly gridRows = [
    [{ width: 64, name: line('42%', '14px'), detail: line('28%', '11px') }],
    [
      { width: 32, name: line('58%', '14px'), detail: line('40%', '11px') },
      { width: 32, name: line('46%', '14px'), detail: line('34%', '11px') },
    ],
    [{ width: 48, name: line('36%', '14px'), detail: line('24%', '11px') }],
    [
      { width: 24, name: line('64%', '14px'), detail: line('44%', '11px') },
      { width: 40, name: line('38%', '14px'), detail: line('30%', '11px') },
    ],
  ];

  readonly fieldRows = [
    { name: line('52%', '14px'), label: line('36%', '11px'), badge: line('44px', '16px') },
    { name: line('40%', '14px'), label: line('30%', '11px'), badge: line('64px', '16px') },
    { name: line('58%', '14px'), label: line('42%', '11px'), badge: line('52px', '16px') },
    { name: line('46%', '14px'), label: line('34%', '11px'), badge: line('40px', '16px') },
    { name: line('36%', '14px'), label: line('26%', '11px'), badge: line('60px', '16px') },
  ];

  readonly theme = {
    icon: { width: '24px', height: '24px', margin: '0' },
    action: { width: '22px', height: '22px', margin: '0' },
    fieldsTitle: line('110px', '22px'),
    search: { width: '100%', height: '40px', 'border-radius': '4px', margin: '0' },
    previewTitle: line('90px', '18px'),
    preview: { width: '100%', height: '120px', 'border-radius': '4px', margin: '0' },
  };
}
